import React from 'react';
import connectToStores from 'fluxible-addons-react/connectToStores';
import Popover from '../../../client/components/Popover';
import shallowCompare from '../../lib/shallowCompare';
import BookmarkActions from '../../actions/BookmarkActions';
import BookmarkStore from '../../stores/BookmarkStore';
import BookmarksList from '../BookmarksList';
import Store from '../../models/Store';
import HeartPng from '../Navbar/images/nav_heart.png';
import HeartSvg from '../Navbar/images/nav_heart.svg';
import TealHeartPng from '../Navbar/images/nav_heart_selected.png';
import TealHeartSvg from '../Navbar/images/nav_heart_selected.svg';
import styles from './index.sass';

class BookmarksPopover extends React.Component {
  static propTypes = {
    bookmarkStoreState: React.PropTypes.object,
    store: React.PropTypes.instanceOf(Store),
    currentRoute: React.PropTypes.object
  };

  static contextTypes = {
    executeAction: React.PropTypes.func,
    trackEvent: React.PropTypes.func
  };

  constructor(props) {
    super(props);

    this.state = {
      popoverIsOpen : false
    };
  }

  componentWillReceiveProps(nextProps) {
    if(this.props.currentRoute !== nextProps.currentRoute) {
      this.setState({popoverIsOpen: false});
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  componentDidUpdate(prevProps, prevState) {
    if(!prevState.popoverIsOpen && this.state.popoverIsOpen) {
      this.context.trackEvent('view', {value: 'saved'});
    }
  }

  handleOnBodyClick(e) {
    this.setState({popoverIsOpen: false});
  }

  handleOnClickHeartLink(e) {
    let isOpen = !this.state.popoverIsOpen;
    this.setState({popoverIsOpen: isOpen});
    if(isOpen) {
      this.context.executeAction(BookmarkActions.list, {});
    }
  }

  render() {
    let { popoverIsOpen } = this.state;
    let bookmarksListProps = {
      ...this.props.bookmarkStoreState,
      store: this.props.store
    };
    let popoverBody = (
      <div className={styles.bookmarksPopover}>
        <p className={styles.header}>Saved</p>
        <div className={styles.listWrapper}>
          <BookmarksList {...bookmarksListProps} />
        </div>
      </div>
    );
    let popoverProps = {
      body        : popoverBody,
      position    : 'right',
      isOpen      : popoverIsOpen,
      onBodyClick : this.handleOnBodyClick.bind(this),
      bodyClassName : styles.popoverBody,
      bodyStyle   : {}
    };
    let heartLinkButtonProps = {
      className: styles.heartLink,
      onClick: this.handleOnClickHeartLink.bind(this)
    };

    return (
      <Popover {...popoverProps}>
        <button {...heartLinkButtonProps}>
          <img className={styles.icon} src={popoverIsOpen ? TealHeartPng : HeartPng} srcSet={popoverIsOpen ? TealHeartSvg : HeartSvg} />
        </button>
      </Popover>
    );
  }
}

BookmarksPopover = connectToStores(BookmarksPopover, [BookmarkStore], (context, props) => {
  return {
    bookmarkStoreState: context.getStore(BookmarkStore).getCurrentState()
  };
});

export default BookmarksPopover;



// WEBPACK FOOTER //
// banquet/components/BookmarksPopover/index.js